'use strict';

var $ = require('jquery');
var triggerEvent = require('../lib/triggerEvent.js');

function setupSwatchViewer() {
	var $left = $('.swatchViewer__control--L[data-setup != "true"]');

	function getActive() {
		return $('.' + activeStyleClass);
	}
	function changeActive($newItem) {
		var $activeItem = getActive();

		// Change image
		var image = $newItem.attr('data-image');
		$swatchViewer_behind.css('background-image', 'url(' + image + ')');
		$swatchViewer_behind.find('img').attr('src', image);
		$swatchViewer_behind.find('img').attr('alt', $newItem.attr('data-imagealt'));
		$swatchViewer_behind.removeClass(swatchViewerDeactive);
		$swatchViewer.addClass(swatchViewerDeactive);

		// Change name
		var name = $newItem.attr('data-name');
		$swatchName.text(name);

		// Trade which one to use for the next image
		var temp = $swatchViewer;
		$swatchViewer = $swatchViewer_behind;
		$swatchViewer_behind = temp;

		// Change class on selected
		$activeItem.removeClass(activeStyleClass);
		$newItem.addClass(activeStyleClass);
	}

	if ($left.length != 0) {
		// If in iframe (so the modal)
		var inIFrame = window.parent != window;
		if (inIFrame) {
			// For mobile, add 'return to results' and contact in header
			var $headerFilters = $('<a href="#" class="returnToResults"><span>Return to Results</span></a> <a href="contact-us/general-question.html"><span>Contact Us</span></a>');
			var $headerFiltersContainer = $('.header__bottomContainer');

			$headerFiltersContainer.append($headerFilters);
			$headerFiltersContainer.find('.returnToResults').on('click', function(event) {
				event.preventDefault();
				triggerEvent(window.parent.document, 'returnToResults');
			});

			// Listen for scroll and notify parent when reach a certain point
			// so the 'return to results' on left can be moved out some
			var $currSwatchImage = $('.swatchViewer__currentImage');
			var triggerAt = $currSwatchImage.offset().top + ($currSwatchImage.outerHeight() / 4);
			var past = false;
			window.addEventListener('scroll', function(e) {
				if (window.scrollY > triggerAt) {
					if (!past) {
						triggerEvent(window.parent.document, 'productLineScrolledDown');
						past = true;
					}
				} else if (past) {
					// Scrolled back up
					triggerEvent(window.parent.document, 'productLineScrolledUp');
					past = false;
				}
			});

			// Register listener to close modal if esc pressed
			$(document).on('keyup', function(event) {
				if (event.key == 'Escape') {
					triggerEvent(window.parent.document, 'returnToResults');
				}
			});
		}


		// Add attribute we use to ensure we do not setup the same viewer multiple times
		$left.attr('data-setup', 'true');

		var swatchesStyleClass 		= 'swatchViewer__swatch';
		var activeStyleClass 		= 'swatchViewer__swatch--active';
		var swatchViewerDeactive 	= 'swatchViewer__currentImage--deactive';

		var $right = $('.swatchViewer__control--R');

		// Obtain reference to where we display the image
		// Then duplicate it so we can use it to have a nice transition between images
		var $swatchViewer = $('.swatchViewer__currentImage');
		var $swatchViewer_behind = $swatchViewer.clone();
		$swatchViewer_behind.addClass(swatchViewerDeactive);
		$swatchViewer_behind.insertAfter($swatchViewer);

		// Name
		var $swatchName = $('.swatchViewer__currentName');

		$left.on('click', function() {
			var $activeItem = getActive();

			// Determine previous
			var $newItem = $activeItem.prev('.' + swatchesStyleClass);
			if ($newItem.length === 0)
				$newItem = $('.' + swatchesStyleClass + ':last');

			changeActive($newItem);
		});

		$right.on('click', function() {
			var $activeItem = getActive();

			// Determine next
			var $newItem = $activeItem.next('.' + swatchesStyleClass);
			if ($newItem.length === 0)
				$newItem = $('.' + swatchesStyleClass + ':first');

			changeActive($newItem);
		});

		$('.' + swatchesStyleClass).on('click', function(event) {
			event.preventDefault();

			var $newItem = $(this);
			changeActive($newItem);
		});
	}
}
module.exports = {
	init : function() {
		function setup() {
			if ($('.__productLine').length === 0 && $('.__productLine2024').length === 0)
				return;

			setupSwatchViewer();
		}
		setup();
		$(window).on('documentModified', setup);
	}
};
